const content: { [key: string]: any } = {
  title: {
    pageTitle: "Non-Bonusable BV",
    pageDescription: "IBOs who are below 60% VCS and generating Non-Bonusable BV",
  },
  export: {
    button: "Export",
    title: "Export Report",
    description: "This report will include a list of ABOs in your group with non-bonusable business volume.",
    exportTypeLabel: "Non-Bonusable BV",
  },
  table: {
    columns: {
      aboName: "ABO Name / Number",
      nonBonusableBV: "Non-Bonusable BV",
      personalVcsPercent: "VCS %",
      personalPV: "PPV",
      vcsPV: "VCS PV",
      watchlist: "Watchlist",
    },
  },
  losTreeView: "LOS Tree View",
} as const;

export default content;
